import React from 'react';
import { Stopwatch } from 'react-bootstrap-icons';

import { ChipBackgroundColor, ChipLabelColor } from '../Chip/types';
import Chip from '../Chip/Chip';
import { UrgencyLevel } from './types';

interface UrgencyChipProps {
  urgency?: UrgencyLevel;
}
const UrgencyChip = ({ urgency = UrgencyLevel.TODAY }: UrgencyChipProps) => {
  const colors = React.useMemo(() => {
    switch (urgency) {
      case UrgencyLevel.TODAY:
        return {
          bgColor: ChipBackgroundColor.RED,
          labelColor: ChipLabelColor.RED,
        };
      case UrgencyLevel.TWO_DAYS:
        return {
          bgColor: ChipBackgroundColor.YELLOW,
          labelColor: ChipLabelColor.YELLOW,
        };
      default:
        return {
          bgColor: ChipBackgroundColor.GREEN,
          labelColor: ChipLabelColor.GREEN,
        };
    }
  }, [urgency]);
  return (
    <Chip
      labelText={urgency}
      icon={<Stopwatch size={12} />}
      backgroundColor={colors.bgColor}
      labelColor={colors.labelColor}
    />
  );
};

export default UrgencyChip;
